import Banner from './Banner';
import HowItWorks from './HowItWorks';
import WhyStorePickup from './WhyStorePickup';
import Testimonial from './testimonial';
import Faq from './faq';
import imageToPath from './images';

const STORE_PICKUP_PATH = '/store-pickup';
const STORE_RETURN_PATH = '/store-return';

const PAGE_OPTIONS_PICKUP = {
  nav: [
    {
      label: 'Store Pickup',
      id: 'banner',
      Component: Banner,
      data: {
        images: {
          storeLogo: imageToPath.store_circle,
          banner_store_desktop: imageToPath.banner_store_desktop,
          banner_store_mobile: imageToPath.banner_store_mobile
        },
        altContent: {
          storeLogoAlt: 'Store icon',
          banner_store_desktopAlt: 'Banner',
          banner_store_mobileAlt: 'Banner'
        },
        content: {
          bannerHeaderText: 'Store Pickup',
          bannerSubheaderText:
            'Collect your orders from the nearby Trends store at your convenience',
          pincodePlaceholderText: 'Enter pin-code to check'
        }
      }
    },
    {
      label: 'How It Works',
      id: 'howitworks',
      Component: HowItWorks,
      data: {
        images: {
          desktopBanner: imageToPath.store_path,
          desktopAlt: 'Store pickup image',
          mobileBanners: [
            {
              banner: imageToPath.ajio_logo_circle,
              text: 'Place an order on AJIO.COM',
              alt: 'Ajio logo'
            },
            {
              banner: imageToPath.uncolor_store_circle,
              text: 'Choose <span className="highLight">Store Pickup</span>',
              alt: 'Store icon'
            },
            {
              banner: imageToPath.geo_location_circle,
              text: 'Select the store near you',
              alt: 'Location icon'
            },
            {
              banner: imageToPath.shooping_bag_circle,
              text: 'Pickup the order at your convenience',
              alt: 'Shopping bag icon'
            }
          ]
        },
        content: {
          headerText: 'How it Works'
        }
      }
    },
    {
      label: 'Testimonials',
      id: 'testimonial',
      Component: Testimonial
    },
    {
      label: 'Why Store Pickup',
      id: 'whystorepickup',
      Component: WhyStorePickup,
      data: {
        images: {
          banners: [
            {
              banner: imageToPath.dispatch_circle,
              text: 'No more missed deliveries',
              alt: 'Dispatch icon'
            },
            {
              banner: imageToPath.group_location_circle,
              text: 'More than 800 stores',
              alt: 'Location icon'
            },
            {
              banner: imageToPath.mirror_circle,
              text: 'Try and return instantly',
              alt: 'Mirror icon'
            },
            {
              banner: imageToPath.rupee_circle,
              text: 'Instant refund',
              alt: 'Rupee icon'
            }
          ]
        },
        content: {
          headerText: 'Why Store Pickup'
        }
      }
    },
    {
      label: 'Faq',
      id: 'faq',
      Component: Faq,
      data: {
        images: {},
        content: {
          headerText: 'FAQ'
        }
      }
    }
  ]
};

const PAGE_OPTIONS_RETURN = {
  nav: [
    {
      label: 'Store Return',
      id: 'banner',
      Component: Banner,
      data: {
        images: {
          storeLogo: imageToPath.store_return_logo,
          banner_store_desktop: imageToPath.banner_store_desktop,
          banner_store_mobile: imageToPath.banner_store_mobile
        },
        altContent: {
          storeLogoAlt: 'Store icon',
          banner_store_desktopAlt: 'Banner',
          banner_store_mobileAlt: 'Banner'
        },
        content: {
          bannerHeaderText: 'Store Return',
          bannerSubheaderText: 'Drop your returns at nearby Trends store',
          pincodePlaceholderText: 'Enter pin-code to check'
        }
      }
    },
    {
      label: 'How it Works',
      id: 'howitworks',
      Component: HowItWorks,
      data: {
        images: {
          desktopBanner: imageToPath.sr_desktop_howitworks_banner,
          mobileBanners: [
            {
              banner: imageToPath.sr_nearest_store,
              text: 'Find the nearest store',
              alt: 'Location icon'
            },
            {
              banner: imageToPath.sr_items_with_tags,
              text: 'Take unused return items with tags to the store',
              alt: 'Bag icon'
            },
            {
              banner: imageToPath.sr_howitworks_instant_refund,
              text: 'Get instant refund*',
              alt: 'Instant refund logo'
            }
          ]
        },
        content: {
          headerText: 'How it Works'
        }
      }
    },
    {
      label: 'Testimonials',
      id: 'testimonial',
      Component: Testimonial
    },
    {
      label: 'Why Store Return',
      id: 'whystorepickup',
      Component: WhyStorePickup,
      data: {
        images: {
          banners: [
            {
              banner: imageToPath.sr_instant_return,
              text: 'Instant Return,<br />no waiting for return pickup',
              alt: 'Instant return logo'
            },
            {
              banner: imageToPath.sr_more_stores,
              text: 'More than 800 stores',
              alt: 'Location icon'
            },
            {
              banner: imageToPath.sr_store_options,
              text: 'Find other options in store',
              alt: 'Store icon'
            },
            {
              banner: imageToPath.sr_howitworks_instant_refund,
              text: 'Instant refund',
              alt: 'Instant refund logo'
            }
          ]
        },
        content: {
          headerText: 'Why Store Return'
        }
      }
    },
    {
      label: 'FAQ',
      id: 'faq',
      Component: Faq,
      data: {
        images: {},
        content: {
          headerText: 'FAQ'
        }
      }
    }
  ]
};

const COMMON_PAGE_DATA = {
  images: {
    banner_store_desktop: imageToPath.banner_store_desktop,
    banner_store_mobile: imageToPath.banner_store_mobile
  },
  content: {
    checkAvailabilityText: 'Check Availability',
    pinCode: {
      labelText: 'Enter Pincode',
      placeholderText: 'Enter pin-code to check',
      headerText: 'Enter Pincode to Find Store',
      subHeaderText: 'Find the nearest store',
      errorMessagText: 'Please Enter Valid Pincode',
      buttonText: 'Check',
      refund: {
        available: {
          classes: 'rfnd-cash-able',
          message: 'Cash refund available'
        },
        unAvailable: {
          classes: 'rfnd-cash-unable',
          message: 'Cash refund unavailable'
        }
      },
      error: {
        headerText: 'No stores in this area',
        subHeaderText: 'We are adding more stores, check in again soon or try another pincode.'
      },
      landmarkText: 'Landmark'
    }
  }
};

export {
  STORE_PICKUP_PATH,
  STORE_RETURN_PATH,
  COMMON_PAGE_DATA,
  PAGE_OPTIONS_PICKUP,
  PAGE_OPTIONS_RETURN
};
